var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDoctorSignCrossIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50033 0.231934C3.03418 0.231934 0.232422 3.03369 0.232422 6.49984C0.232422 9.96599 3.03418 12.7677 6.50033 12.7677C9.96648 12.7677 12.7682 9.96599 12.7682 6.49984C12.7682 3.03369 9.96648 0.231934 6.50033 0.231934ZM9.63428 8.75002L8.75051 9.6338L6.50033 7.38362L4.25015 9.6338L3.36638 8.75002L5.61656 6.49984L3.36638 4.24966L4.25015 3.36589L6.50033 5.61607L8.75051 3.36589L9.63428 4.24966L7.38411 6.49984L9.63428 8.75002Z",
    fill: "#E15554"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDoctorSignCrossIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Doctor_Sign_Cross_Icon.7c4842f6.svg";
export { ForwardRef as ReactComponent };